var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("© "+_vm._s(_vm.$t("footer-powered-by", { version : _vm.version })))])])])}
var staticRenderFns = []

export { render, staticRenderFns }